import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles'
import MUIListItemText from 'material-ui/List/ListItemText'

const styles = theme => ({})

const PanelItemText = (props) => (
  <MUIListItemText {...props}>{props.children}</MUIListItemText>
)

PanelItemText.propTypes = {
  children: PropTypes.node,
}

export default withStyles(styles, {withTheme: true})(PanelItemText)



// WEBPACK FOOTER //
// ./src/components/panelItemText.jsx